module.exports = __webpack_public_path__ + "img/webcam.65d5dab4.svg";